import React, { PropTypes } from 'react'
import { CreateAccountPost } from 'guest-payment'
import $ from 'jquery'

import AppActions from '../actions/AppActions'
import AppStore from '../stores/AppStore';

import * as FPT from '../utility/fpt'

const STYLES = {
    logo:{
        width: '30px',
        height: '35px',
        marginBottom: '20px'
    },
	modal: {
		background: 'white'
	},
    prefillEmail:{
        marginBottom: '-20px'
    },
    notNow:{
        marginTop: '10px'
    }
}

export default React.createClass({

	getInitialState () {

        let confirmationData = AppStore.getConfirmation() || {}

		return {
            isOfacPending: confirmationData.isOfacPending
        };
	},

    propTypes: {},

    contextTypes: {
      router: React.PropTypes.object.isRequired
    },

    componentDidMount () {
        // Firing beacons only when modal opens.
        $('#guestCreateAccountdialog').on('show.bs.modal', function (e) {
            FPT.trackPage('main:donate:wps:guest:upgrade', 'main:donate:wps:guest:upgrade:web::')
        })
    },

	handleSignUp (password) {

        $('.spinneroverlay').show();

        FPT.trackLinkClick('createAccount');

        $.post('/donate/guest/upgrade', {
            password: password
        })
        .then((response) => {

            let confirmationData = response.data.confirmationData || {}
            AppActions.updateConfirmation({ confirmation: confirmationData });

        })
        .always((response) => {

            $('.spinneroverlay').hide()
            this.handleContinue()
        })
	},

    handleContinue () {
        $('#guestCreateAccountdialog').modal('hide')
        if (this.state.isOfacPending) {
            this.context.router.push('/donate/guest/pending')
        } else {
            this.context.router.push('/donate/guest/confirmation')
        }
    },

	render () {

		return (
          <div className="modal fade guestCreateAccountdialog"
              style={STYLES.modal}
          		tabIndex="-1"
          		role="dialog"
          		id="guestCreateAccountdialog"
          		data-backdrop="static">
            	<div className="modal-dialog">
              	<div className="modal-content">
                    <div className="text-center donateCreateAccountLogo">
                          <img style={STYLES.logo} src={this.props.pplogo} />
                    </div>
                		<div className="donateCreateAccountHeader">
                            <p className="text-center createline1">{this.props.mainTitle1}</p>
                            <p className="text-center createline2">{this.props.mainTitle2}</p>
                            <p className="text-center createline3">{this.props.mainTitle3}</p>
                		</div>
                  	<div className="donateCreateAccountPost password_fields" style={STYLES.donateCreateAccountPost}>
                        <div className="vx_form-group" style={STYLES.prefillEmail}>
                            <input
                                className="form-control vx_form-control"
                                type="email"
                                id="email"
                                name="email"
                                disabled="true"
                                value={this.props.email} />
                        </div>
                        <CreateAccountPost {...this.props} handleSubmit={this.handleSignUp}/>
                        <div className="text-center" style={STYLES.notNow}>
                            <a href="#" onClick={this.handleContinue}>{this.props.notNow}</a>
                        </div>
                  	</div>
              	</div>
        	   </div>
          </div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./common/signUpPanel.js
 **/